<template>
  <div class="sidebar">
    <div class="logo">
      <router-link to="/">
        <img v-show="!collapse" src="/static/img/CMK_Logo.png" alt="" >
        <img v-show="collapse" src="/static/img/CMK_Logo_white_coll.png" >
      </router-link>
    </div>
    <el-menu
      :show-timeout="200"
      :collapse="collapse"
      :default-active="path"
      mode="vertical"
      @select="path => menuSelect(path)"
      :collapse-transition="false">
      <Items 
        v-for="item in routes" 
        :key="item.path" 
        :menu-item="item" />
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '@/router'
import Items from './Items'
export default {
  name: 'default',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['collapse', 'authList']),
    routes(){
      let cpRoutes = JSON.parse(JSON.stringify(router.options.routes));
      return this.filterRoutes(cpRoutes);
    },
    path(){
      let result = this.$route.path;
      if(result.substr(-1) === '/') result = result.substr(0, result.length - 1)
      return result
    }
  },
  components: {
    Items
  },
  methods: {
    filterRoutes(routes, prevPath = ''){
      return routes.map(item => {
        //判断是否需要隐藏
        if(item.hidden) return null;
        
        //判断权限是否匹配
        let metaAuth = item.meta && item.meta.auth ? item.meta.auth : null;
        if(metaAuth && this.authList.indexOf(metaAuth) == -1)
          return null;
        
        //设置path
        item.path = this.pathCombine(prevPath, item.path);

        //过滤子项
        if(item.children && item.children.length) item.children = this.filterRoutes(item.children, item.path);

        //alwaysShow
        if(!item.alwaysShow && item.children && item.children.length == 1) item = {...item.children[0], ...{ meta: { ...item.meta, ...item.children[0].meta } }};

        //设置isRoot
        if(!item.children || !item.children.length) item.isRoot = true;
        return item;
      }).filter(item => item ? true: false)
    },
    pathCombine(prevPath, path){
      let result = '';
      if(prevPath[0] === '/') prevPath = prevPath.substr(1);
      if(path[0] === '/') path = path.substr(1);
      if(prevPath) result += '/' + prevPath;
      if(path) result += '/' + path;
      return result
    },
    menuSelect(path){
      /^(https?:|mailto:|tel:)/.test(path)
      ? window.open(path, 'blank').location
      : this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar/index.vue